module.exports = __webpack_public_path__ + "img/dbm_logo.f31b3ec1.png";